module.exports = __webpack_public_path__ + "img/img_brand18.901c66d0.jpg";